/* eslint-disable react/no-set-state,react/no-string-refs  */
import React from 'react';
import Close from '@tradera/tradera-ui/icons/close?jsx';

const Tooltip = ({ content, closeTooltip, visible, position }) => {
    return (
        <div
            data-tooltip
            className={`tooltip-search bp ${position} ${
                visible ? 'tooltip--show' : ''
            }`}>
            <span className="tooltip-close " onClick={closeTooltip}>
                <Close className="icon" />
            </span>
            <div className="tooltip-content">{content}</div>
        </div>
    );
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/tooltip/tooltip.jsx